module.exports = __webpack_public_path__ + "img/ring_r_i_0_null@2x.6bc4ca68.png";